module.exports = __webpack_public_path__ + "media/country_flags/bt-3538d5de.png";